import React, { useEffect } from "react";

const CameraPermission = ({ onPermissionGranted }) => {
  useEffect(() => {
    const requestPermissions = async () => {
      // Check if the browser supports media devices
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        alert("Your browser does not support camera and microphone access.");
        console.error("Camera and microphone access not supported.");
        onPermissionGranted(false);
        return;
      }

      try {
        // Request camera and microphone permissions
        console.log("Requesting camera and microphone permissions...");
        await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
        console.log("Permissions granted.");
        onPermissionGranted(true); // Notify the parent component
      } catch (err) {
        console.error("Permission denied:", err.message);
        alert(
          "Camera and microphone permissions are required to proceed. Please allow them in your browser settings."
        );
        onPermissionGranted(false); // Notify the parent component of failure
      }
    };

    requestPermissions();
  }, [onPermissionGranted]);

  return (
    <div className="container">
      <h1>Grant Permissions</h1>
      <p>Please allow access to your camera and microphone to continue.</p>
    </div>
  );
};

export default CameraPermission;
